import { useEffect, useState } from 'react';

export const useVideoUrl = (videoInput: string | Blob[] | null) => {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!videoInput) return setVideoUrl(null);
    if (typeof videoInput === 'string') {
      setVideoUrl(videoInput);
      return;
    }

    if (videoInput.length === 0) return;

    const superBlob = new Blob(videoInput, { type: 'video/mp4' });
    const url = URL.createObjectURL(superBlob);
    setVideoUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [videoInput]);

  return videoUrl;
};
